<rt-icon [name]="cardType | rtCreditCardVendorIcon: 'credit-card'" />
&nbsp;••••&nbsp;••••&nbsp;••••&nbsp;{{ cardLast4Digits }}
<rt-divider variant="dot" />
{{
  'app.pricing.billing_page.credit_card_expires'
    | translate: { date: cardExpirationDate | amDateFormat: 'MM / YYYY' }
}}
